import { useEffect, useState } from 'react';
import { apiFetch } from '../../api/api';
import MediaTile from './MediaTile';
import UploadMediaPanel from './UploadMediaPanel';
import { toast } from 'react-toastify';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import './tabs.css';
import './media.css';

const MediaLibraryPanel = ({
  organizationId,
  onAdd,
  canAdd,
}) => {

  const [mediaCache, setMediaCache] = useState({
    image: null,
    video: null
  });

  const [loading, setLoading] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);

  const currentType = tabIndex === 1 ? 'video' : 'image';
  const media = mediaCache[currentType] || [];

  const handleUploaded = () => {
    // invalidate ONLY current tab
    setMediaCache(prev => ({
      ...prev,
      [currentType]: null
    }));
    setRefreshKey(k => k + 1);
  };

  const setMenuPage = (index) => {
    setTabIndex(index);
  };

  useEffect(() => {
    if (!organizationId) return;

    // ✅ already cached → skip fetch
    if (mediaCache[currentType]) return;

    let mounted = true;

    async function load() {
      setLoading(true);
      try {
        const res = await apiFetch(
          `/media?organization=${organizationId}&type=${currentType}`
        );

        if (!mounted) return;

        setMediaCache(prev => ({
          ...prev,
          [currentType]: res.items || []
        }));

      } catch (err) {
        console.error(err);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    load();

    return () => { mounted = false; };

  }, [organizationId, currentType, refreshKey]);

  const handleDelete = async (item) => {
    try {
      await apiFetch(`/media/${item._id}`, { method: 'DELETE' });

      // remove from cache without refetch
      setMediaCache(prev => ({
        ...prev,
        [item.type]: prev[item.type].filter(x => x._id !== item._id)
      }));

      toast.success('Deleted');

    } catch (err) {
      toast.error(err.message);
    }
  };

  return (
    <Tabs className="Tabs" selectedIndex={tabIndex} onSelect={setMenuPage}>
      <TabList>
        <Tab>Image Library</Tab>
        <Tab>Video Library</Tab>
        <Tab>Upload</Tab>
      </TabList>

      <TabPanel>
        <div className="media-grid">
          {media.map(m => (
            <MediaTile
              key={m._id}
              media={m}
              canAdd={canAdd}
              onAdd={onAdd}
              onDelete={handleDelete}
            />
          ))}
        </div>
      </TabPanel>

      <TabPanel>
        <div className="media-grid">
          {media.map(m => (
            <MediaTile
              key={m._id}
              media={m}
              canAdd={canAdd}
              onAdd={onAdd}
              onDelete={handleDelete}
            />
          ))}
        </div>
      </TabPanel>

      <TabPanel>
        <div className="media-library">
          <UploadMediaPanel
            orgId={organizationId}
            onUploaded={handleUploaded}
          />
          {loading && <div>Loading…</div>}
        </div>
      </TabPanel>

    </Tabs>
  );
};

export default MediaLibraryPanel;
